import { render, staticRenderFns } from "./mock.vue?vue&type=template&id=43366753&scoped=true&"
import script from "./mock.vue?vue&type=script&lang=js&"
export * from "./mock.vue?vue&type=script&lang=js&"
import style0 from "./mock.vue?vue&type=style&index=0&id=43366753&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43366753",
  null
  
)

export default component.exports